import { DEFAULT_FEATURE_FLAGS, FeatureFlags } from '../types/featureFlags';

export function resolveFeatureFlags(value: unknown): FeatureFlags {
    const resolved = { ...DEFAULT_FEATURE_FLAGS };
    if (!value || typeof value !== 'object' || Array.isArray(value)) return resolved;

    const supplied = value as Record<string, unknown>;
    for (const key of Object.keys(DEFAULT_FEATURE_FLAGS) as Array<keyof FeatureFlags>) {
        if (typeof supplied[key] === 'boolean') resolved[key] = supplied[key];
    }
    return resolved;
}
